import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { Auth } from '../services/auth';

export const authRedirectGuard: CanActivateFn = (route, state) => {
  const authService = inject(Auth);
  const router = inject(Router);
  if (authService.getIsLoggingOut()) {
    return true;
  }

  return authService.isAuthenticated().pipe(
    map((isAuthenticated) => {
      // If user is authenticated, redirect to dashboard
      if (isAuthenticated) {
        return router.createUrlTree(['/']);
      }

      // If user is not authenticated, allow access to auth pages
      return true;
    }),
    catchError((error) => {
      console.error('Auth redirect guard error:', error);
      // On error, allow access to auth page
      return of(true);
    }),
  );
};

// Injectable({
//   providedIn: 'root',
// });
// export class AuthRedirectGuard implements CanActivate {
//   private router = inject(Router);
//   private authService = inject(Auth);

//   canActivate(
//     route: ActivatedRouteSnapshot
//   ):
//     | Observable<boolean | UrlTree>
//     | Promise<boolean | UrlTree>
//     | boolean
//     | UrlTree {
//     // If logout is in progress, allow access to auth pages
//     if (this.authService.getIsLoggingOut()) {
//       return true;
//     }

//     return this.authService.isAuthenticated().pipe(
//       map((isAuthenticated) => {
//         // If user is authenticated, redirect to dashboard
//         if (isAuthenticated) {
//           return this.router.createUrlTree(['/']);
//         }

//         // If user is not authenticated, allow access to auth pages
//         return true;
//       }),
//       catchError((error) => {
//         console.error('Auth redirect guard error:', error);
//         // On error, allow access to auth page
//         return of(true);
//       })
//     );
//   }
// }
